import { EMPTY_ARRAY, IApplicationState, TBoardId } from '../../../../../../types/types';

export const getMyWorkShowBoards = (
    state: IApplicationState,
): TBoardId[] => {
    return state.myWork && state.myWork.showBoards || EMPTY_ARRAY;
};
